export type IntegrationCredentials = {
  id: string;
  hubSpotAccessToken?: string | null;
  komboIntegrationId?: string | null;
  provider?: string | null;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  appSubdomain?: string | null;
};

export type JobLocation = {
  id: string;
  name: string;
};

export type RejectedReason = {
  type: string;
  id: string;
  remoteId?: string | null;
  label: string;
};

export type InterviewStage = {
  id: string;
  remoteId?: string | null;
  name: string;
};

export type TypeformRecord = {
  id: string;
  formId: string;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
};

export type AtsList = {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  type: {
    value: string;
    sourceValue: null;
  };
  items: {
    id: string;
  }[];
  campaignId?: string;
};

export enum AtsProvider {
  bullhorn = 'bullhorn',
  bullhorn_ats = 'bullhorn_ats',
  greenhouse = 'greenhouse',
  lever = 'lever',
  pinpoint = 'pinpoint',
  logic_melon = 'logicmelon'
}
